import { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Grid, IconButton, InputAdornment, Typography } from "@mui/material";

import pages from "../../../constants/pages";
import { TextField } from "../../../components";
import { colors } from "../../css components/Style";
import Logo from "../../../assets/grow_logo-removebg-preview.png";
import { PrimaryLoadingButton } from "../../css components/Button";
import { LockOutline, MailOutline } from "@mui/icons-material";

export default function FormDisplay({ formikProps }) {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Fragment>
      <Grid container spacing={2} className="login-grid">
        <Grid size={12}>
          <Typography
            className="form-title"
            style={{ color: colors.growthOSDarkBlue }}
          >
            CONNECTED ID
          </Typography>{" "}
        </Grid>

        <Grid size={12}>
          <TextField
            required
            formikProps={formikProps}
            name="email"
            placeholder="Email address"
            label="Email address"
            InputLabelProps={{ shrink: true }}
            autoComplete="off"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <MailOutline />
                  </InputAdornment>
                ),
              },
            }}
          />
        </Grid>

        <div style={{ marginBottom: "10px" }} />

        <Grid size={12}>
          <TextField
            required
            label="Password"
            autoComplete="off"
            type={showPassword ? "text" : "password"}
            name="password"
            formikProps={formikProps}
            placeholder="Password"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <LockOutline />
                  </InputAdornment>
                ),

                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      style={{ padding: 0 }}
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {!showPassword && <VisibilityOffIcon />}
                      {showPassword && <VisibilityIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
          />
        </Grid>

        <Grid size={12}>
          <PrimaryLoadingButton
            className="login-button"
            fullWidth={true}
            type="submit"
            variant="contained"
            onClick={formikProps.handleSubmit}
            disabled={!formikProps.dirty || !formikProps.isValid}
            loading={formikProps.isSubmitting}
          >
            Log In
          </PrimaryLoadingButton>
        </Grid>

        <Grid size={12} className="form-links">
          <Typography className="signup-link" variant="button">
            Don't have an account? &nbsp;
            <Typography
              variant="button"
              style={{ cursor: "pointer", color: colors.growthOSDarkBlue }}
              onClick={() => navigate("/sign-up")}
            >
              Create One
            </Typography>
          </Typography>

          <br />

          <Typography variant="button">
            <Typography
              className="forgot-link"
              variant="button"
              style={{ cursor: "pointer", color: colors.growthOSDarkBlue }}
              onClick={() => navigate(pages.resetEmailPasswordPage.route)}
            >
              Forgot Password?
            </Typography>
          </Typography>
        </Grid>
      </Grid>

      <div className="footer-branding">
        <span>Powered by</span>
        <div className="growth-os-logo">
          <img
            src={Logo}
            alt="1"
            style={{ height: "25px", position: "relative", top: "-3px" }}
          />
        </div>
      </div>
    </Fragment>
  );
}
